let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dzTo5")).then(() => parcelRequire('ckkdR'));